import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { normalizeAppLocale, persistAppLanguage } from "@/shared/lib/appLocale";

export function useSelectLang() {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(() => normalizeAppLocale(i18n.language));

  const changeLanguage = useCallback(
    (lng: string) => {
      const normalized = persistAppLanguage(lng);
      setLang(normalized);
      void i18n.changeLanguage(normalized);
    },
    [i18n]
  );

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setLang(normalizeAppLocale(lng));
    };
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return {
    lang,
    changeLanguage,
  };
}
